import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-qa-run-list',
  templateUrl: './qa-run-list.component.html',
  styleUrls: ['./qa-run-list.component.css'],
})
export class QaRunListComponent {
  url: string = 'qaRun';
  data: Array<any> = [];
  searchText = '';
  filteredData: Array<any> = [];
  searchSuggestions: string[] = [];
  currentPage: number = 1;
  morePages: boolean = true;
  itemsPerPage: number = 50;
  type = '';
  form!: FormGroup;
  selectedQa: any = null;
  detailsOpen = false;
  detailsLoading = false;
  rejectOpen = false;
  id!: string;
  modalTitle: string = '';
  modalContent: string | null = null;

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/marketing',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/marketing/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/marketing/social/strategy',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'GEO',
      route: '',
    },
    
  ];

  constructor(
    private dataService: DataService,
    private messageService: MessageService,
    private fb: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.getData();
    this.form = this.fb.group({
      rejectReason: ['', [Validators.required]],
    });
  }

  getData(): void {
    this.dataService
      .getDataTwo(this.url, '', this.type, this.currentPage, this.itemsPerPage)
      .subscribe((response) => {
        console.log('response get', response);
        this.data = response.data;
        // Ordenar por updatedAt (el más reciente primero)
        // this.data = response.data.sort((a, b) => {
        //   return (
        //     new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        //   );
        // });
        this.filteredData = [...this.data];
        this.updateSuggestions();
      });
  }

  deleteData(id: string): void {
    if (!confirm('¿Desea eliminar el registro?')) {
      return;
    }

    this.dataService
      .deleteData(`${this.url}/delete/${id}`)
      .subscribe((response) => {
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }

        this.getData();
      });
  }

  filter() {
    const t = this.searchText.trim().toLowerCase();
    if (!t) {
      this.filteredData = [...this.data];
      return;
    }

    this.filteredData = this.data.filter((x) => {
      const hay = [
        x.urlPath,
        x.type,
        x.city,
        x.service,
        x.industry,
        x.status,
        x.approvalState,
        String(x.postIdWp || ''),
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();
      return hay.includes(t);
    });
  }

  updateSuggestions() {
    const set = new Set<string>();
    this.data.forEach((x) => x.urlPath && set.add(x.urlPath));
    this.searchSuggestions = Array.from(set);
  }

  qaApprove(id: string): void {
    console.log('approve', this.form.value);

    this.dataService
      .postData(`${this.url}/approve/${id}`, {})
      .subscribe((response) => {
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
          this.form.reset();
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  qaReject(): void {
    console.log('reject', this.form.value);

    this.dataService
      .postData(`${this.url}/reject/${this.id}`, this.form.value)
      .subscribe((response) => {
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
          this.form.reset();
          this.closeReject();
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  badgePassed(passed: boolean) {
    return passed ? 'badge-success' : 'badge-danger';
  }

  badgeQaStatus(status: string) {
    // qa_blocked / review_required
    if (status === 'review_required') return 'badge-warning'; // o success si quieres
    if (status === 'qa_blocked') return 'badge-danger';
    return 'badge-secondary';
  }

  badgeApproval(state: string) {
    // pending / approved / rejected
    if (state === 'approved') return 'badge-success';
    if (state === 'rejected') return 'badge-danger';
    return 'badge-secondary'; // pending
  }

  openDetails(item: any) {
    this.detailsOpen = true;
    this.detailsLoading = true;
    this.selectedQa = null;

    this.dataService.getData(`${this.url}/${item._id}`).subscribe({
      next: (res: any) => {
        if (res?.rst) {
          this.selectedQa = res.data;
        } else {
          this.messageService.add(
            res?.msg || 'No se pudo cargar el detalle',
            'secondary',
          );
          this.detailsLoading = false;
        }
        this.detailsLoading = false;
      },
      error: () => {
        this.messageService.add('Error cargando detalle QA', 'secondary');
        this.detailsLoading = false;
      },
    });
  }

  closeDetails() {
    this.detailsOpen = false;
    this.selectedQa = null;
  }

  badgeSeverity(sev: string) {
    if (sev === 'blocker') return 'badge-danger';
    if (sev === 'major') return 'badge-warning';
    if (sev === 'minor') return 'badge-info';
    return 'badge-secondary';
  }

  openReject(id: string): void {
    this.rejectOpen = true;
    this.id = id;
    this.form.reset();
  }

  closeReject() {
    this.rejectOpen = false;
    this.id = '';
    this.form.reset();
  }

  showModal(title: string, content: string) {
    this.modalTitle = title;
    this.modalContent = content;
  }

  closeModal() {
    this.modalContent = null;
  }
}
